export const projectStatusRows = [
  // Dashboard
  {
    category: "Dashboard",
    srsFile: "00_dashboard.html",
    feature: "Dashboard overview",
    logic: "done",
    ui: "done",
  },

  // Employee
  {
    category: "Employee",
    srsFile: "01_employee_list.html",
    feature: "Employee list",
    logic: "done",
    ui: "done",
  },
  {
    category: "Employee",
    srsFile: "01_01_employee_detail.html",
    feature: "Employee detail",
    logic: "done",
    ui: "done",
  },
  {
    category: "Employee",
    srsFile: "01_02_employee_add.html",
    feature: "Employee add",
    logic: "done",
    ui: "done",
  },
  {
    category: "Employee",
    srsFile: "work_history_detail.html",
    feature: "Work history detail",
    logic: "done",
    ui: "done",
  },

  // Timekeeping / Requests / Payroll data inputs
  {
    category: "Timekeeping",
    srsFile: "02_01_attendance.html",
    feature: "Daily attendance",
    logic: "done",
    ui: "done",
  },

  {
    category: "Payroll Data",
    srsFile: "02_02_shift_change_list.html",
    feature: "Shift change list",
    logic: "done",
    ui: "done",
  },
  {
    category: "Payroll Data",
    srsFile: "02_02_shift_change_detail.html",
    feature: "Shift change detail",
    logic: "done",
    ui: "done",
  },
  {
    category: "Payroll Data",
    srsFile: "02_02_01_shift_change_detail.html",
    feature: "Shift change detail (alt)",
    logic: "done",
    ui: "done",
  },
  {
    category: "Payroll Data",
    srsFile: "02_02_shift_change_detail_create.html",
    feature: "Shift change create",
    logic: "done",
    ui: "done",
  },
  {
    category: "Payroll Data",
    srsFile: "02_02_shift_change_detail_edit.html",
    feature: "Shift change edit",
    logic: "done",
    ui: "done",
  },

  {
    category: "Payroll Data",
    srsFile: "02_03_approval.html",
    feature: "Leave request list",
    logic: "done",
    ui: "done",
  },
  {
    category: "Payroll Data",
    srsFile: "02_03_01_approval_detail.html",
    feature: "Leave request detail",
    logic: "done",
    ui: "done",
  },
  {
    category: "Payroll Data",
    srsFile: "02_03_01_approval_detail_create.html",
    feature: "Leave request create",
    logic: "done",
    ui: "done",
  },
  {
    category: "Payroll Data",
    srsFile: "02_03_01_approval_detail_edit.html",
    feature: "Leave request edit",
    logic: "done",
    ui: "done",
  },

  {
    category: "Payroll Data",
    srsFile: "02_04_01_overtime_list.html",
    feature: "Overtime list",
    logic: "done",
    ui: "done",
  },
  {
    category: "Payroll Data",
    srsFile: "02_04_01_overtime_detail.html",
    feature: "Overtime detail",
    logic: "done",
    ui: "done",
  },
  {
    category: "Payroll Data",
    srsFile: "02_04_01_overtime_create.html",
    feature: "Overtime create",
    logic: "done",
    ui: "done",
  },

  {
    category: "Payroll Data",
    srsFile: "02_05_late_permission_list.html",
    feature: "Late/Early list",
    logic: "done",
    ui: "done",
  },
  {
    category: "Payroll Data",
    srsFile: "02_05_late_permission_detail.html",
    feature: "Late/Early detail",
    logic: "done",
    ui: "done",
  },
  {
    category: "Payroll Data",
    srsFile: "02_05_permission_create.html",
    feature: "Late/Early create",
    logic: "done",
    ui: "done",
  },

  {
    category: "Payroll Data",
    srsFile: "02_06_bonus_list.html",
    feature: "Bonus list",
    logic: "done",
    ui: "done",
  },
  {
    category: "Payroll Data",
    srsFile: "02_06_bonus_detail.html",
    feature: "Bonus detail",
    logic: "done",
    ui: "done",
  },
  {
    category: "Payroll Data",
    srsFile: "02_06_bonus_create.html",
    feature: "Bonus create",
    logic: "done",
    ui: "done",
  },

  {
    category: "Payroll Data",
    srsFile: "02_07_deduction_list.html",
    feature: "Deduction list",
    logic: "done",
    ui: "done",
  },
  {
    category: "Payroll Data",
    srsFile: "02_07_deduction_detail.html",
    feature: "Deduction detail",
    logic: "done",
    ui: "done",
  },
  {
    category: "Payroll Data",
    srsFile: "02_07_deduction_create.html",
    feature: "Deduction create",
    logic: "done",
    ui: "done",
  },

  // Payroll calculation
  {
    category: "Payroll Calculation",
    srsFile: "03_payroll_period_list.html",
    feature: "Payroll period list",
    logic: "partial",
    ui: "done",
  },
  {
    category: "Payroll Calculation",
    srsFile: "03_01_payroll_list.html",
    feature: "Payroll list (employees in period)",
    logic: "partial",
    ui: "done",
  },
  {
    category: "Payroll Calculation",
    srsFile: "03_01_01_payroll_detail.html",
    feature: "Payslip detail",
    logic: "partial",
    ui: "done",
  },

  // Payroll payment
  {
    category: "Payroll Payment",
    srsFile: "04_payroll_payment_period_list.html",
    feature: "Payment period list",
    logic: "partial",
    ui: "done",
  },
  {
    category: "Payroll Payment",
    srsFile: "04_01_payroll_payment_list.html",
    feature: "Payment detail list",
    logic: "partial",
    ui: "done",
  },
  {
    category: "Payroll Payment",
    srsFile: "03_payroll_table.html",
    feature: "Payroll payment table (prototype parity)",
    logic: "partial",
    ui: "partial",
  },

  // Settings
  {
    category: "Settings",
    srsFile: "05_01_payroll_general_setting.html",
    feature: "Default system settings",
    logic: "done",
    ui: "done",
  },
  {
    category: "Settings",
    srsFile: "05_02_salary_components.html",
    feature: "Salary components",
    logic: "done",
    ui: "done",
  },
  {
    category: "Settings",
    srsFile: "05_03_02_salary_component_create.html",
    feature: "Salary component create",
    logic: "done",
    ui: "done",
  },
  {
    category: "Settings",
    srsFile: "05_03_salary_template.html",
    feature: "Salary templates",
    logic: "done",
    ui: "done",
  },
  {
    category: "Settings",
    srsFile: "05_03_01_salary_template_create.html",
    feature: "Salary template create",
    logic: "done",
    ui: "done",
  },
  {
    category: "Settings",
    srsFile: "05_03_01_salary_template_edit.html",
    feature: "Salary template edit",
    logic: "done",
    ui: "done",
  },
  {
    category: "Settings",
    srsFile: "05_04_department_setting.html",
    feature: "Department settings",
    logic: "done",
    ui: "done",
  },
  {
    category: "Settings",
    srsFile: "05_05_shift_group_setting.html",
    feature: "Shift settings",
    logic: "done",
    ui: "done",
  },
  {
    category: "Settings",
    srsFile: "05_06_user_list.html",
    feature: "User list",
    logic: "done",
    ui: "done",
  },
  {
    category: "Settings",
    srsFile: "05_07_leave_manager.html",
    feature: "Leave management settings",
    logic: "done",
    ui: "done",
  },
  {
    category: "Settings",
    srsFile: "05_07_01_leave_manager_detail.html",
    feature: "Leave type detail",
    logic: "done",
    ui: "done",
  },
  {
    category: "Settings",
    srsFile: "05_07_01_leave_manager_detail_backup.html",
    feature: "Leave type detail (backup)",
    logic: "done",
    ui: "done",
  },

  // Self-service
  {
    category: "Self-Service",
    srsFile: "06_01_sf_staff_detail.html",
    feature: "Self-service profile",
    logic: "done",
    ui: "done",
  },
  {
    category: "Self-Service",
    srsFile: "06_02_sf_staff_payroll.html",
    feature: "Self-service payslip",
    logic: "done",
    ui: "done",
  },
  {
    category: "Self-Service",
    srsFile: "06_03_sf_staff_salary_component.html",
    feature: "Self-service salary components",
    logic: "done",
    ui: "done",
  },
  {
    category: "Self-Service",
    srsFile: "06_04_sf_staff_approval.html",
    feature: "Self-service requests",
    logic: "done",
    ui: "done",
  },

  // Support
  {
    category: "Support",
    srsFile: "mobile_support.html",
    feature: "Mobile support / responsive note",
    logic: "na",
    ui: "done",
  },
]
